export default __webpack_public_path__ + "static/media/eth.bb26646d.svg";